module.exports = __webpack_public_path__ + "static/media/POOL-101-badge.1086a8d6.svg";